import axios, { AxiosResponse } from 'axios';

import { ETypPrihlaseni } from 'services/profily';

import { ETypZadosti } from 'enums/lei/leiTypZadosti';

type DateTimeString = string;

export interface ILeiLoginLessInput {
    typzadosti: ETypZadosti;
    regentity?: string;
    jurisdikce?: string;
    regauthority?: string;
    lei?: string;
}

export enum EstavLeiLoginless {
    OK = 'OK',
    UNAUTHJURISD = 'UNAUTHJURISD',
    LOUCDCP = 'LOUCDCP',
    JINELOU = 'JINELOU',
    LEINEEXISTUJE = 'LEINEEXISTUJE',
    ICNEEXISTUJE = 'ICNEEXISTUJE',
    REGPOVINNY = 'REGPOVINNY'
}

export interface ILeiLoginLessData {
    legalentityidentifier: string;
    registrationauthorityentityid: string;
    jurisdikce: string;
    legalname?: string;
    address?: string;
    registrationstatus?: string;
    initialregistrationdate?: DateTimeString;
    lastupdatedate?: DateTimeString;
    nextrenewaldate?: DateTimeString;
    regauthority: string;
    managinglou?: string;
    louname?: string;
    stav?: EstavLeiLoginless;
    typzadosti: string;
}

export const leiCheckLoginless = (data?: ILeiLoginLessInput) => {
    return axios({
        method: 'GET',
        url: '/LEIW/CheckICLEI',
        params: data
    }).then((resp: AxiosResponse<ILeiLoginLessData>) => resp.data);
};

export interface ILeiLoginLessEmailInput {
    idcaptcha: number;
    captcha: string;
    jmeno: string;
    prijmeni: string;
    email1: string;
    email2: string;
    emailfakt: string;
    telefon: string;
    pozice: string;
    typosoby: string;
    typzadosti: ETypZadosti;
    jurisdikce?: string;
    lei?: string;
    regauthority?: string;
    regentity?: string;
    soubory?: {
        orignazev: string;
        tempnazev: string;
    }[];
}

export enum EEmailStav {
    OK = 'OK', // bez chyby
    CHYBNYFORAMT = 'CHYBNYFORAMT', // chybný formát e-mailu
    CHYBNYSOUBOR = 'CHYBNYSOUBOR', // nepodařilo se dohledat soubor
    CHYBAODESLANI = 'CHYBAODESLANI' // nepodařilo se odeslat e-mail
}

export const leiEmailOvereni = (data: ILeiLoginLessEmailInput) => {
    return axios({
        method: 'POST',
        url: '/LEIW/EmailOver/',
        data: data
    }).then(
        (
            resp: AxiosResponse<{
                stav: EEmailStav;
                hash: string;
            }>
        ) => resp.data
    );
};

export const leiLoginlessZalozitZadost = (data: { hash: string; kod: string; token?: string }) => {
    return axios({
        method: 'POST',
        url: '/LEIW/Zadost/',
        data: data
    }).then(
        (
            resp: AxiosResponse<{
                stav: EEmailStav;
                token: string;
                uzivateloid: number;
                ucetoid: number;
                zadostoid: number;
                varsymbol: string;
            }>
        ) => resp.data
    );
};

export enum EStavUzivatele {
    CHYBNYKOD = 'CHYBNYKOD', // Kód zadaný uživatelem je chybný.
    NEEXISTUJE = 'NEEXISTUJE', // Uživatel neexistuje, je potřeba pro něj založit účet.
    EXISTUJE = 'EXISTUJE', // Uživatel existuje, lze jej automaticky přihlásit do MD LEI.
    MUSI = 'MUSI', // Uživatel existuje, do MD LEI se musí přihlásit.
    MUZE = 'MUZE' // Uživatel existuje, do MD LEI se může přihlásit nebo může požadovat založení účtu.
}

export interface ILeiLoginlessCheckUserResp {
    stav: EStavUzivatele;
    typyuctu: ETypPrihlaseni[];
}

export const leiLoginlessUserCheck = (data: { hash: string; kod: string }) => {
    return axios({
        method: 'POST',
        url: '/LEIW/CheckOsoba/',
        data: data
    }).then((resp: AxiosResponse<ILeiLoginlessCheckUserResp>) => resp.data);
};

export enum EStavZadostiLoginlessLei {
    NOVA = 'NOVA', // Nová žádíost
    OVERENA = 'OVERENA', // Ověřen e-mail osoby žadatele
    ZALOZENA = 'ZALOZENA', // Žádost založena
    HOTOVO = 'HOTOVO'
}

export interface IRozpZadostData extends ILeiLoginLessEmailInput {
    stav: 'OK' | 'CHYBNYHASH';
    token: string;
    kod: string;
    uzivateloid: number;
    ucetoid: number;
    zadostoid: number;
    stavzadosti: EStavZadostiLoginlessLei;
    typzadosti: ETypZadosti;
    typprihlaseni: string;
    lei: string;
    jurisdikce: string;
    regentity: string;
    regauthority: string;
    varsymbol: string;
    madic: boolean;
    dic?: string;
    hash: string;
    uzivatelnovy?: boolean;
}

export const leiLoginlessGet = (hash?: string) => {
    return axios({
        method: 'GET',
        url: '/LEIW/Zadost/',
        params: {
            hash: hash
        }
    }).then((resp: AxiosResponse<IRozpZadostData>) => resp.data);
};

export const leiLoginlessZadostCheck = (data: { hash: string; token: string }) => {
    return axios({
        method: 'POST',
        url: '/LEIW/ZadostOver/',
        data: data
    }).then(
        (
            resp: AxiosResponse<{
                stav: 'OK' | 'CHYBNYHASH' | 'CHYBNYTOKEN' | 'CHYBNYUZIV';
                uzivateloid: number;
                ucetoid: number;
                zadostoid: number;
                varsym: string;
            }>
        ) => resp.data
    );
};
